import { Trans } from '@lingui/react';
import React, { useState } from 'react';
import { TransButtonDefault, TransButtonLinkWithIcon } from '../../Atoms/Buttons';
import { ModalDialog } from '../Dialogs';
import AttachmentList from './AttachmentList';

const ChatMessageAttachmentButton = ({ event, iconOnly, emailTemplate, templateName }) => {
  const [open, setOpen] = useState(false);

  return (
    <div>
      <TransButtonLinkWithIcon
        icon="ATTACHMENTS"
        className="primary-link"
        onClick={() => {
          setOpen(true);
        }}
        text={iconOnly ? undefined : emailTemplate ? 'Anhänge voreinstellen' : 'message.attach.file'}
        color="default-new"
      />

      <ModalDialog
        help="help.email.attachments.available.pane"
        header={<Trans id="message.attach.file" />}
        body={
          <AttachmentList
            eventId={event ? event.id : undefined}
            emailTemplate={emailTemplate}
            templateName={templateName}
          />
        }
        footer={
          <TransButtonDefault
            onClickHandler={() => {
              setOpen(false);
            }}
            text="actions.close"
          />
        }
        show={open}
        toggle={() => {
          setOpen(false);
        }}
      />
    </div>
  );
};

export default ChatMessageAttachmentButton;
